import {Component, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-task-body-default-view',
  templateUrl: './task-body-default-view.component.html',
  styleUrls: ['./task-body-default-view.component.scss']
})
export class TaskBodyDefaultViewComponent implements OnInit {
  @Input() data: any;
  @Input() taskMenuItemsMapper: any = {};
  @Output() openAddAttachmentDialog$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Output() focusAddCommentBox$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  actionEvent$: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() { }

  ngOnInit(): void {
  }

  onActionEvent($event: {id: string, type: string, card: any}) {
    switch ($event.type) {
      case 'AddAttachment':
        this.openAddAttachmentDialog$.next(true);
        break;
      case 'AddComment':
        this.focusAddCommentBox$.next(true);
        break;
      default:
        this.actionEvent$.next($event);
        break;
    }
  }
}
